import LockIcon from '@mui/icons-material/Lock'
import {Button} from '@mui/material'
import React from 'react'
import {useAuth0} from '@auth0/auth0-react'

const LogInButton = () => {
  const {loginWithPopup} = useAuth0()

  return (
    <Button
      sx={{
        padding: 0, // Remove default padding to match Link styling
        minWidth: 'auto', // Remove the button's default width
        textTransform: 'none', // Prevent uppercase transformation
        color: 'secondary.main', // Use the primary color like a Link
        textDecoration: 'none', // Ensure no default button styling
        fontWeight: 'normal', // Match Link font-weight
        '&:hover': {
          textDecoration: 'underline', // Add underline on hover like a Link
          backgroundColor: 'transparent', // Avoid background color on hover
        },
      }}
      onClick={() =>
        loginWithPopup(
          {
            authorizationParams: {
              redirect_uri:
                process.env.REACT_APP_LEARNING_URL ??
                'https://learn.blackspectacles.com/',
            },
          },
          {
            timeoutInSeconds: 360,
          },
        )
      }
    >
      <LockIcon /> Log in
    </Button>
  )
}

export default LogInButton
